import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import { lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { Icon } from '../..';
import { eventLocations } from '../../../../constants';
import ToggleBox from '../../toggle-box';

const LocationFilter = ({
  onLocationChange,
  toggleFilter,
  showFilter,
  eventLocations
}) => {
  return (
    <div className='filter status-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'>
            {
              showFilter ?
                <Icon icon='minus-large'></Icon> :
                <Icon icon='plus-large'></Icon>
            }
            <span id='label'>Location</span>
          </h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Collapse id='location-filter' in={showFilter}>
          <div>
            <form id='selection-list'>
              <div>
                {
                  fp.flow(
                    fp.map(
                      ({ value, label, selected }) => {
                        const boxLabel = selected ? <FiCheck /> : null
                        return <Row className={classNames('no-gutter flexbox align-center', { selected })} id='selection' key={value} onClick={
                          () => {
                            onLocationChange(value)
                          }
                        }>
                          <span id='checkbox'>
                            <ToggleBox
                              small
                              value={value}
                              label={boxLabel}
                              checked={selected} />
                          </span>
                          <span>{label}</span>
                        </Row>
                      }
                    )
                  )(eventLocations)
                }
              </div>
            </form>
          </div>
        </Collapse>
      </Row>
    </div>
  )
}

const getUpdatedLocation = (eventLocations, locationToToggle) => fp.flow(
  fp.map(
    (status) => ({
      ...status,
      selected: status.value === locationToToggle ? !status.selected : status.selected
    })
  )
)(eventLocations)

export default compose(
  withStateHandlers(
    {
      showFilter: false
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      })
    }
  ),
  withStateHandlers(
    () => ({
      eventLocations: fp.map(
        (status) => ({
          ...status,
          selected: false
        })
      )(eventLocations)
    }),
    {
      setLocation: () => (eventLocations) => ({
        eventLocations
      }),
      resetLocation: () => (filter) => ({
        eventLocations: fp.map(
          (location) => ({
            ...location,
            selected: fp.includes(location.value)(filter.locations)
          })
        )(eventLocations)
      })
    }
  ),
  withHandlers({
    onLocationChange: ({ onChange, setLocation, eventLocations }) => (status) => {
      const updatedLocations = getUpdatedLocation(eventLocations, status)
      setLocation(updatedLocations)
      const selectedLocations = fp.flow(
        fp.filter('selected'),
        fp.map('value')
      )(updatedLocations)
      onChange({
        locations: selectedLocations
      })
    }
  }),
  lifecycle({
    componentDidUpdate(prevStat) {
      const { filter, resetLocation } = this.props
      if (!fp.isEqual(filter)(prevStat.filter)) {
        resetLocation(filter)
      }
    }
  })
)(LocationFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/location-filter.js